<template>
  <div>
    <app-tile
      :label="$t('projects.project-types.ProjectTypeArchive.label')"
      :caption="$t('projects.project-types.ProjectTypeArchive.caption')"
      icon="inventory_2"
      icon-color="icon-grey"
      icon-background-color="surface-grey-subtle"
      data-locator="electronic-safe-tile"
      @click="onArchivesCardClicked"
    />

    <DiscoverElectronicSafeDialog v-if="discoverDialogIsOpen"
                                  @close="discoverDialogIsOpen = false"
                                  @requestActivation="openQuoteRequestDialog"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

import archiveCategoryIcon from '@/assets/img/project/archive-category-filled.svg'
import { QUOTE_REQUEST_TOPICS } from '@/common/utils/quoteRequestTopics'
import { ARCHIVES_ROUTE_NAME } from '@/router/routerData'
import { getRouter } from '@/router/routerInstance'
import { SET_PROJECT_TYPE_QUOTE_REQUEST_DIALOG } from '@/store/modules/subscription/mutation_types'

import DiscoverElectronicSafeDialog from '../dialogs/DiscoverElectronicSafeDialog.vue'

export default {
  name: 'ProjectTypeArchive',
  components: {
    DiscoverElectronicSafeDialog,
  },
  data () {
    return {
      ARCHIVES_ROUTE_NAME,
      archiveCategoryIcon,
      discoverDialogIsOpen: false,
    }
  },
  computed: {
    ...mapGetters('user', ['isArchivingEnabled']),
  },
  methods: {
    ...mapMutations('subscription', [SET_PROJECT_TYPE_QUOTE_REQUEST_DIALOG]),
    onArchivesCardClicked () {
      if (this.isArchivingEnabled) {
        getRouter().push({ name: ARCHIVES_ROUTE_NAME })
      } else {
        this.discoverDialogIsOpen = true
      }
    },
    openQuoteRequestDialog () {
      this.SET_PROJECT_TYPE_QUOTE_REQUEST_DIALOG({
        isOpen: true,
        defaultProjectType: QUOTE_REQUEST_TOPICS.ELECTRONIC_SAFE,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .discover-label {
    color: #626262;
  }
</style>
